import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteLearnDriverFace } from '../../services/DriversService';
import { Driver, DeleteLearnFaceRequest } from '../../types/Drivers';

type Result = UseMutationResult<Driver, Error, DeleteLearnFaceRequest>;

function useDeleteLearnDriverFace(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteLearnDriverFace, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['driver'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteLearnDriverFace;
